export default __webpack_public_path__ + "static/media/video.c74f510d.gif";